import React from "react";
import { SelectRegistrationForm } from "../components/SelectRegistrationForm";
import { registerObject, subEventCreateState } from "../../../types/types";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions/allActions";
import * as eState from "../../eventReducer";
import { BreadRoute } from "../../../components/breadcrumbs/BreadRoute";
import { BreadCrumb } from "../../../components/breadcrumbs/BreadCrumb";

export const SelectRegistration: React.FC = () => {
  const dispatch = useDispatch();
  const formName = "selectRegistration";
  const { eventId, subEventId, subEventCreateState } = useSelector(
    eState.getEventState
  );
  const selectRegistration = (data: { RegistrationType: string }) => {
    const newSubEventState: subEventCreateState = {
      ...subEventCreateState,
      eventPage:
        data.RegistrationType.toLowerCase() ===
        "ContactMate-Registration".toLowerCase()
          ? false
          : true,
      createRegistration:
        data.RegistrationType.toLowerCase() ===
        "ContactMate-Registration".toLowerCase()
          ? true
          : false,
      selectRegistration: false,
    };
    const regObj: registerObject = {
      registerName: `CM-Registration-${eventId}`,
      eventId: eventId,
      subEventCreateState: newSubEventState,
      subEventId: subEventId,
    };
    dispatch(allActions.eventActions.saveRegister(regObj));
  };

  //Tämä sivu tulee silloin kun on luonut uuden tapahtuman, ja sitten se tuo suoraan tähän rekisteröinnin valintaan.
  //TODO: Tänne joku teksti, että "Hei, aloitetaan tapahtuman luominen määrittelemällä tapahtuman rekisteröinti!"

  return (
    <div className='container w-screen h-screen'>
      <BreadRoute>
        <BreadCrumb label={"menu"} link={"/eventmenu"} />
        <BreadCrumb label={"events"} link={"/events"} />
        <BreadCrumb
          label={`${eventId} selectregistration`}
          link={`/events/${eventId}`}
          lastChild={true}
        />
      </BreadRoute>
      <div className='container h-full max-h-11/12 w-full flex flex-col justify-center overflow-auto scroller mx-auto'>
        <SelectRegistrationForm
          formAction={selectRegistration}
          formName={formName}
        />
        <div className='h-2/3 min-h-2/3 overflow-auto'>
          <img
            className='h-full min-h-full'
            src={`${process.env.PUBLIC_URL}/img/5283.jpg`}
            alt={`image_choosing`}
          />
        </div>
      </div>
    </div>
  );
};

export default SelectRegistration;
